module.exports = __webpack_public_path__ + "static/img/banner_3.a0aa18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/banner_3.jpg
// module id = Ve/l
// module chunks = 19